import { multiTicketProperty } from "../../property/resource/multi-ticket-property";
import { ResourceColumn } from "../planner-column";

export const multiTicketColumn = new ResourceColumn(
  'Multi-Draw Tickets',
  'stl_item_usable_0084.png',
  'multiTickets',
  multiTicketProperty,
)
